import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to-today"
// Horizontally scrolls the overflow container so today's column is centered.
export default class extends Controller {
  static targets = ["todayColumn"];

  connect() {
    if (!this.hasTodayColumnTarget) return;

    const column = this.todayColumnTarget;
    const scroller = this.element;

    const columnLeft = column.offsetLeft;
    const columnWidth = column.offsetWidth;
    const scrollerWidth = scroller.offsetWidth;

    scroller.scrollLeft = columnLeft - scrollerWidth / 2 + columnWidth / 2;
  }
}
